import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import api from "../api";
import { toast } from "sonner";
import { Lock, ShieldAlert } from "lucide-react";

const CambioPasswordPage = () => {
  const { user, refreshUser, logout } = useAuth();
  const navigate = useNavigate();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);
  const forced = !!user?.must_change_password;

  const submit = async (e) => {
    e.preventDefault();
    if (next.length < 6) { toast.error("La nuova password deve avere almeno 6 caratteri"); return; }
    if (next !== confirm) { toast.error("Le password non coincidono"); return; }
    setSaving(true);
    try {
      await api.post("/profile/password", { current_password: current, new_password: next });
      await refreshUser();
      toast.success("Password aggiornata! Benvenuto.");
      navigate("/");
    } catch (err) { toast.error(err?.response?.data?.detail || "Errore"); }
    finally { setSaving(false); }
  };

  const inputCls = "w-full border border-gray-300 rounded-sm px-3 py-2.5 text-[14px] outline-none focus:border-[#16345c]";

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#16345c] to-[#0d1b2f] flex items-center justify-center px-4" data-testid="cambio-password-page">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-[420px] p-7">
        <div className="flex items-center gap-2 text-[#e30613] mb-2"><ShieldAlert size={22} /><span className="text-[12px] font-bold uppercase tracking-wide">Cambio password obbligatorio</span></div>
        <h1 className="text-[22px] font-black text-[#16345c] mb-1">Imposta la tua password</h1>
        <p className="text-[13px] text-gray-500 mb-5">{forced ? "Per motivi di sicurezza devi cambiare la password temporanea prima di usare la piattaforma." : "Aggiorna la tua password."}</p>
        <form onSubmit={submit} className="space-y-3">
          <div>
            <label className="block text-[12px] font-semibold text-gray-600 mb-1">Password attuale (temporanea)</label>
            <input type="password" value={current} data-testid="cp-current" onChange={(e) => setCurrent(e.target.value)} className={inputCls} />
          </div>
          <div>
            <label className="block text-[12px] font-semibold text-gray-600 mb-1">Nuova password</label>
            <input type="password" value={next} data-testid="cp-new" onChange={(e) => setNext(e.target.value)} className={inputCls} />
          </div>
          <div>
            <label className="block text-[12px] font-semibold text-gray-600 mb-1">Conferma nuova password</label>
            <input type="password" value={confirm} data-testid="cp-confirm" onChange={(e) => setConfirm(e.target.value)} className={inputCls} />
          </div>
          <button type="submit" disabled={saving} data-testid="cp-submit" className="w-full flex items-center justify-center gap-2 bg-[#16345c] hover:bg-[#0d1b2f] text-white font-bold text-[14px] py-2.5 rounded-sm transition-colors disabled:opacity-60">
            <Lock size={16} /> {saving ? "Aggiornamento..." : "Cambia password"}
          </button>
        </form>
        <button onClick={() => { logout(); navigate("/login"); }} className="w-full mt-3 text-[12px] text-gray-500 hover:text-[#c00510] transition-colors">Esci</button>
      </div>
    </div>
  );
};

export default CambioPasswordPage;
